module.exports = __webpack_public_path__ + "static/media/kitchen_bundle_icon.4dead544.svg";